import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcMenu32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m5 22.984c0-.476.281-.984 1-.984h20c.563 0 1 .445 1 1.016 0 .476-.281.984-1 .984h-20c-.563 0-1-.444-1-1.016zm0-7c0-.476.281-.984 1-.984h16c.563 0 1 .445 1 1.016 0 .476-.281.984-1 .984h-16c-.563 0-1-.444-1-1.016zm0-7c0-.476.281-.984 1-.984h20c.563 0 1 .444 1 1.016 0 .476-.281.984-1 .984h-20c-.563 0-1-.445-1-1.016z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcMenu32;
